import { render } from "./MMemberCenter.vue?vue&type=template&id=604231b0&scoped=true"
import script from "./MMemberCenter.vue?vue&type=script&lang=js"
export * from "./MMemberCenter.vue?vue&type=script&lang=js"

import "./MMemberCenter.vue?vue&type=style&index=0&id=604231b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604231b0"]])

export default __exports__